<template>
  <a-modal
    :title="formTitle || '新增公告'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
    >
      <!--      <a-form-item label="公告类型" name="noticeType" >-->
      <!--        <a-select placeholder="请选择" v-model:value="form.noticeType" style="width: 100%;" >-->
      <!--          <a-select-option :key="1">通知</a-select-option>-->
      <!--          <a-select-option :key="2">公告</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-item>-->
      <a-form-item label="标题" name="noticeTitle">
        <a-input
          v-model:value="form.noticeTitle"
          placeholder="请输入标题"
        />
      </a-form-item>
      <a-form-item label="图片" name="imgUrl">
        <file-upload
          v-model:value="form.imgUrl"
          type="image"
          @change="changeSwiper"
        ></file-upload>
      </a-form-item>
      <a-form-item label="内容" name="noticeContent">
        <editor v-model:value="form.noticeContent" />
      </a-form-item>
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'

import { getNotice, addNotice, updateNotice } from '@/api/system/notice'
import Editor from '@/components/Editor'
import bus from '@/utils/bus'
import events from '@/components/MultiTab/events'

export default {
  name: 'NoticeForm',
  components: {
    Editor,
  },
  dicts: ['sys_notice_status', 'sys_notice_type'],
  data() {
    return {
      wrapperCol: { span: 48 },
      submitLoading: false,
      total: 0,
      id: undefined,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        noticeTitle: undefined,
        noticeType: 1,
        noticeContent: '',
        imgUrl: null,
        status: 1,
        bstatus: 1,
      },
      rules: {
        noticeType: [
          { required: true, message: '公告类型不能为空', trigger: 'change' },
        ],
        noticeTitle: [
          { required: true, message: '公告标题不能为空', trigger: 'blur' },
        ],
        noticeContent: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
      },
      open: false,
    }
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
    /* this.id = this.$route.params.id
  this.formTitle = this.$route.params.formTitle
  if (this.id) {
    this.handleUpdate(this.id)
  } else {
    this.handleAdd()
  }*/
  },
  methods: {
    changeSwiper(e) {
      console.log(e)
      this.form.imgUrl = e
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    changeStatus(e) {
      let status = e.target.value
      this.form.status = status === '0' ? '1' : '0'
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        noticeTitle: undefined,
        noticeType: 1,
        noticeContent: '',
        imgUrl: null,
        status: 1,
        bstatus: 1,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.formTitle = '添加公告'
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      const noticeId = id
      getNotice(noticeId).then((response) => {
        let str = response.data.status
        response.data['bstatus'] = str
        this.form = response.data
        this.open = true
        this.formTitle = '修改公告'
      })
    },
    /** 提交按钮 */
    submitForm: async function () {
      try {
        await this.$refs.formRef.validate()
        if (this.form.id !== undefined) {
          await updateNotice(this.form)
          this.$message.success('修改成功', 3)
          this.open = false
          $emit(this, 'ok')
        } else {
          await addNotice(this.form)
          this.$message.success('新增成功', 3)
          this.open = false
          $emit(this, 'ok')
        }
      } catch (error) {
        return false
      } finally {
        this.submitLoading = false
      }
    },
    back() {
      let pages = this.$store.pages
      pages.indexOf(this.$route)
      $emit(events, 'close', pages.indexOf(this.$route))
      this.$router.push('/system/notice')
    },
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    handleSubmit() {
      this.$refs.baseForm.validate((valid) => {
        if (valid) {
          this.open = true
        } else {
          return false
        }
      })
    },
    //关闭当前标签页
  },
  emits: ['close', 'ok'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px !important;
  padding-top: 24px !important;
  border-top: 1px solid #f0f0f0 !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 24px !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Label 文字左对齐，与输入框左边对齐 */
.create-form-modal .ant-form-item-label {
  padding-right: 0 !important;
  text-align: left !important;
}

.create-form-modal .ant-form-item-label > label {
  text-align: left !important;
  justify-content: flex-start !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 确保表单项不会超出 */
.create-form-modal .ant-form-item {
  margin-bottom: 24px !important;
  overflow: visible !important;
  width: 100% !important;
  max-width: 100% !important;
}

.create-form-modal .ant-form-item-control {
  max-width: 100% !important;
  overflow: hidden !important;
  width: 100% !important;
}

/* 富文本编辑器外层容器 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}
</style>

<style>
/* 富文本编辑器全局样式 - 防止超出 Modal（使用全局样式确保生效） */
.create-form-modal .ant-form-item-control-input-content #editor,
.create-form-modal .ant-form-item-control-input-content .editor {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* wangeditor 主容器 - 确保宽度100% */
.create-form-modal .ant-form-item-control-input-content > div {
  width: 100% !important;
  box-sizing: border-box !important;
}

/* wangeditor 工具栏 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content .w-e-toolbar,
.create-form-modal .ant-form-item-control-input-content [class*="toolbar"] {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* wangeditor 文本容器 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content .w-e-text-container,
.create-form-modal .ant-form-item-control-input-content .w-e-text-container-wrapper,
.create-form-modal .ant-form-item-control-input-content [class*="text-container"] {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}

/* wangeditor 文本编辑区域 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content .w-e-text,
.create-form-modal .ant-form-item-control-input-content [class*="w-e-text"] {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: auto !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  overflow-wrap: break-word !important;
  margin: 0 !important;
  padding: 8px !important;
}

/* wangeditor 所有内部元素使用 border-box */
.create-form-modal .ant-form-item-control-input-content .w-e * {
  box-sizing: border-box !important;
}
</style>
